import { createFileRoute } from "@tanstack/react-router";
import { ProductionLineGroupStatusView } from "src/components/views/erp/production/productionLineStatus/ProductionLineGroupStatusView.tsx";
import { ProductionLineGroupStatusViewApi } from "src/api/generated/erp/production/productionLineStatus/api/productionLineGroupStatusViewApi.ts";
import { useKeptAliveGeneratedView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute(
	"/_authenticated/_shell/production/productionLineGroupStatus/$productionLineGroupId",
)({
	staticData: {
		legacyViewKey: "productionLineGroupStatusGeneratedViews",
		listGeneratedViews: async () =>
			(await ProductionLineGroupStatusViewApi.getProductionLineGroupsForStatusViewGeneration()).map(
				(productionLineGroup) => ({
					id: productionLineGroup.productionLineGroupId,
					title: productionLineGroup.name,
				}),
			),
	},
	component: RouteComponent,
});

function RouteComponent() {
	const {
		view: { generatedId: id },
		isActive,
	} = useKeptAliveGeneratedView();
	return <ProductionLineGroupStatusView productionLineGroupId={id} isActive={isActive} />;
}
